// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3Aurp","row":"ProcedureTreatmentSummary_row__1PqZ1"};